import {
  ERP_PRODUCT_LIST,
  ERP_PRODUCT_LIST_ERROR,
  DELETE_SERVICE,
  ERP_HMS_MASTER_LOCATION_DETAILS,
} from "../../../core/constants/erpConstants";
import patientServices from "../../../core/services/patientServices";
import { erpServices } from "./erpServices";

export async function getAllSalesOrder(patientId, visitId, locationId) {
  try {
    console.log("Fetching sales order for:", patientId, visitId, locationId);
    const salesOrder = await erpServices.getSalesOrderforVisit(
      patientId,
      visitId,
      locationId
    );
    console.log("Sales order response:", salesOrder);
    return salesOrder;
  } catch (error) {
    console.error("Error in getAllSalesOrder:", error);
    throw error;
  }
}

export async function getPatientAdvPayments(
  patientId,
  visitId,
  locationId,
  fromDate,
  toDate,
  searchQuery
) {
  try {
    console.log(
      "Fetching advance payments for:",
      patientId,
      visitId,
      locationId
    );
    const payments = await erpServices.getERPCustomerAdvPayments(
      patientId,
      visitId,
      locationId,
      fromDate,
      toDate,
      searchQuery
    );
    console.log("Advance payments response:", payments);
    return payments;
  } catch (error) {
    console.error("Error in getPatientAdvPayments:", error);
    throw error;
  }
}

export async function getPatientDetails(patientId) {
  try {
    console.log("Fetching patient details for:", patientId);
    const patientDetail = await erpServices.getERPCustomerDetails(patientId);
    // let patientResp = patientDetail.patientresp;
    // dispatch(successDispatch(ERP_PATIENT_DETAIL, patientDetail.patientResp));
    console.log("Patient details response:", patientDetail);
    return patientDetail;
  } catch (error) {
    console.error("Error in getPatientDetails:", error);
    throw error;
  }
}

export async function getPatientInvoices(payload) {
  try {
    const invoicesResp = await erpServices.getInvoices(payload);
    console.log("Patient Invoices response:", invoicesResp.erpResp);
    return invoicesResp.erpResp;
  } catch (error) {
    console.error("Error in getAllSalesOrder:", error);
    throw error;
  }
}

export function getProductsList(product, patientId, visitId, locationId, onlyBillable) {
  return async (dispatch) => {
    try {
      console.log("Search products :", product, patientId, visitId, locationId, onlyBillable);
      const prodSearchResp = await erpServices.getProductList(
        product,
        patientId,
        visitId,
        locationId,
        onlyBillable
      );
      console.log("Search products response:", prodSearchResp);
      var prodList = [];
      if (prodSearchResp && prodSearchResp.erpProductWServices) {
        let packageServiceList = prodSearchResp.erpProductWServices;
        let packageList = prodSearchResp.erpPackageProductWServiceList;
        // add package products also
        prodList = packageServiceList.concat(packageList);
        // dispatch({ type: ERP_PRODUCT_LIST, payload: prodList });
        dispatch(successDispatch(ERP_PRODUCT_LIST, prodList));
      }
      // return JSON.stringify(prodList);
      return prodList;
    } catch (error) {
      console.error("Error in Search products:", error);
      // dispatch({ type: ERP_PRODUCT_LIST_ERROR, payload: error });
      dispatch(errorDispatch(ERP_PRODUCT_LIST_ERROR, error));
      throw error;
    }
  };
}

export async function getAllBanks() {
  try {
    console.log("Fetch All Banks Details ");
    const bankDetails = await erpServices.getAllBankDetails();
    console.log("Fetch All Banks Details response:", bankDetails);
    var bankList = {};
    if (bankDetails && bankDetails.erpResp) {
      bankList = bankDetails.erpResp;
      // dispatch({ type: ERP_PRODUCT_LIST, payload: prodList });
      // dispatch(successDispatch( ERP_ALL_BANKS_DETAILS, bankList));
    }
    // return JSON.stringify(prodList);
    return bankList;
  } catch (error) {
    console.error("Error while Fetch All Banks Details :", error);
    throw error;
  }
}

export async function savePatientPayment(locationId, patientPaymentInfo) {
  try {
    console.log("Save Patient Advance Payment Details start");
    const paymentResponse = await erpServices.savePatientPaymentInfo(
      locationId,
      patientPaymentInfo
    );
    console.log(
      "Save Patient Advance Payment Details response:",
      paymentResponse
    );
    var pmtResp = {};
    if (paymentResponse && paymentResponse.erpResp) {
      pmtResp = paymentResponse.erpResp;
    }
    return pmtResp;
  } catch (error) {
    console.error("Error while Saving Patient Payment Details:", error);
    throw error;
  }
}

export async function savePatientInvoice(
  locationId,
  invoiceDeatils,
  erpCustId
) {
  // try {
  console.log("Save Patient Invoice Details start");
  const invoiceResponse = await erpServices.generatePatientInvoice(
    locationId,
    invoiceDeatils,
    erpCustId
  );
  console.log("Save Patient Invoice Details response:", invoiceResponse);
  var invResp = {};
  if (invoiceResponse && invoiceResponse.erpResp) {
    invResp = invoiceResponse.erpResp;
  } else {
    // invResp['error'] = invoiceResponse.errorMessages;
    invResp["error"] = invoiceResponse.messageStrip;
  }

  return invResp;
  // } catch (error) {
  //   console.error("Error while Saving Patient Invoice Details:", error);
  //   throw error;
  // }
}

export async function deleteErpService(patientId, visitId, soId, soLineId,actiontype=DELETE_SERVICE,payload = null) {
  try {
    console.log("delete service list");
    const resp = await erpServices.deleteRowErpService(
      patientId,
      visitId,
      soId,
      soLineId,
      actiontype,
      payload
    );
    console.log("delete service list resp:", resp);

    return resp;
  } catch (error) {
    console.error("Error while Saving Patient Invoice Details:", error);
    throw error;
  }
}

export async function UpdateserviceListRow(
  patientId,
  visitId,
  locationId,
  procedure
) {
  try {
    console.log("update service list");
    const resp = await erpServices.UpdateserviceListData(
      patientId,
      visitId,
      locationId,
      procedure
    );
    console.log("update service list resp:", resp);

    return resp;
  } catch (error) {
    console.error("Error while Saving Patient Invoice Details:", error);
    throw error;
  }
}

export async function getOutstandingBills(page, size, locationId, erpCsstId,getAllOutstandingBills,isKpCash) {
  try {
    console.log("Fetch All Outstanding Bills ");
    const outstandingBills = await erpServices.getAllOutstandingBills(
      page,
      size,
      locationId,
      erpCsstId,
      getAllOutstandingBills,
      isKpCash
    );
    console.log("Fetch All Outstanding response:", outstandingBills);
    var outstandingBillList = {};
    if (outstandingBills && outstandingBills.erpResp) {
      outstandingBillList = outstandingBills.erpResp;
      // dispatch({ type: ERP_PRODUCT_LIST, payload: prodList });
      // dispatch(successDispatch( ERP_ALL_BANKS_DETAILS, bankList));
    }
    // return JSON.stringify(prodList);
    return outstandingBillList;
  } catch (error) {
    console.error("Error while Fetch All Banks Details :", error);
    throw error;
  }
}

export async function getAllMasterLocationDetails(dispatch) {
  try {
    console.log("Fetch All masterLocation Resp");
    const masterLocationResp = await erpServices.getMasterLocationDetails();
    console.log("Fetch All masterLocationResp :", masterLocationResp);
    var masterLocationList = {};
    if (masterLocationResp && masterLocationResp.masterlocations) {
      masterLocationList = masterLocationResp.masterlocations;
      if(dispatch){  
        dispatch(successDispatch(ERP_HMS_MASTER_LOCATION_DETAILS, masterLocationList));
      }
      // dispatch({ type: ERP_PRODUCT_LIST, payload: prodList });
      // dispatch(successDispatch( ERP_HMS_MASTER_LOCATION_DETAILS, masterLocationList));
    }
    // return JSON.stringify(prodList);
    return masterLocationList;
  } catch (error) {
    console.error("Error while Fetch All Banks Details :", error);
    throw error;
  }
}

export async function getInvPDF(
  ticketId,
  visitId,
  customerId,
  reportType,
  locationIds
) {
  // export async function getInvPDF(ticketId, visitId, reportType, locationIds) {
  try {
    console.log("Fetch INV PDF Ticket : ", ticketId);

    const invPdfResp = await erpServices.getInvoicePDF(
      ticketId,
      visitId,
      customerId,
      reportType,
      locationIds
    );
    // const invPdfResp = await erpServices.getInvoicePDF(ticketId, visitId, reportType, locationIds);
    // const invPdfResp = {};
    console.log("Fetch INV PDF Resp :", invPdfResp);
    var masterLocationList = {};
    // Make sure it's a successful response and is a PDF
    // if (invPdfResp.ok && invPdfResp.headers.get("content-type") === "application/pdf") {
    if (
      invPdfResp.ok &&
      invPdfResp.headers.get("content-type") === "application/pdf"
    ) {
      const blob = await invPdfResp.blob();
      return blob;
      // } else if (invPdfResp.ok && invPdfResp.headers.get("content-type") === "text/html") {
    } else if (
      invPdfResp.ok &&
      invPdfResp.headers.get("content-type") === "text/html"
    ) {
      // const html = await invPdfResp.text();
      // const htmlBytes = await invPdfResp.arrayBuffer();
      // console.log("Fetch INV PDF Resp :", invPdfResp);
      // const htmlBlob = new Blob([htmlBytes], { type: "text/html" });
      // return htmlBlob;

      let htmlText = await invPdfResp.text(); // get HTML as text instead of arrayBuffer

      // // ✅ Inject CSS before </head> (or create <head> if missing)
      // const customCss = `
      //   <style>
      //     @media print {
      //       body {
      //         width: 100%;
      //         height: auto;
      //       }
      //       @page {
      //         size: auto;
      //         margin: 10mm;
      //       }
      //     }
      //   </style>
      // `;

      // if (htmlText.includes("</head>")) {
      //   htmlText = htmlText.replace("</head>", `${customCss}</head>`);
      // } else {
      //   htmlText = `<head>${customCss}</head>${htmlText}`;
      // }

      const blob = new Blob([htmlText], { type: "text/html" });
      return blob;
    } else {
      console.error(
        "Unexpected response type:",
        invPdfResp.headers.get("content-type")
      );
      throw new Error("Failed to fetch valid PDF file.");
    }
  } catch (error) {
    console.error("Error while Fetch All Banks Details :", error);
    throw error;
  }
}

export async function printPDFFile(fileData) {
  try {
    console.log("Print Invoice PDF");
    const printInv = await erpServices.printInvPDF(fileData);
    console.log("Fetch INV PDF Resp :", printInv);
    var masterLocationList = {};
    // Make sure it's a successful response and is a PDF
    if (printInv.ok) {
      //&& invPdfResp.headers.get("content-type") === "application/pdf") {
      // const blob = await invPdfResp.blob();
      return printInv;
    } else {
      console.error("Unexpected response type:", printInv);
      throw new Error("Failed to Print valid PDF file.");
    }
  } catch (error) {
    console.error("Error while Printing Invoice PDF:", error);
    throw error;
  }
}

export async function validatePatientStatus(patientId, visitId, erpCustId) {
  try {
    console.log("patientId, visitId", patientId, visitId, erpCustId);
    const resp = await erpServices.validatePatientOverallStatus(
      patientId,
      visitId,
      erpCustId
    );
    console.log("Res", resp);
    return resp;
  } catch (error) {
    console.error("Error while Validating the Patient Status:", error);
    throw error;
  }
}

export async function removeInvoice(invoiceObj, userName) {
  try {
    const apiUpdateResp = await erpServices.removeInvoice(invoiceObj, userName);
    const data = await apiUpdateResp;

    return data;
  } catch (error) {
    console.error("Error while deleting invoice : ", error);
    throw error;
  }
}

export async function settleUnclearedInvoices(
  patientId,
  visitId,
  invSettlementDetails
) {
  try {
    console.log(
      "settleUnclearedInvoices Start: patientId, visitId: ",
      patientId,
      visitId,
      invSettlementDetails
    );
    const resp = await erpServices.settleInvoices(
      patientId,
      visitId,
      invSettlementDetails
    );
    console.log("Res", resp);
    return resp;
  } catch (error) {
    console.error("Error while Settling the uncleared :", error);
    throw error;
  }
}
// ravi, kadaga, nagara n weekdays
export async function getPaymentRequests(visitId, status) {
  try {
    console.log("GET Payment Requests Start: visitId: ", visitId, status);
    const resp = await erpServices.getPaymentRequests(visitId, status);
    console.log("Res", resp);
    return resp;
  } catch (error) {
    console.error("Error while Settling the uncleared :", error);
    throw error;
  }
}

export async function savePaymentRequests(patientId, visitId, paymentRequest) {
  try {
    console.log(
      "ADD Payment Requests Start: visitId: ",
      patientId,
      visitId,
      paymentRequest
    );
    const resp = await erpServices.savePaymentRequest(
      patientId,
      visitId,
      paymentRequest
    );
    console.log("Res", resp);
    return resp;
  } catch (error) {
    console.error("Error while Settling the uncleared :", error);
    throw error;
  }
}

export async function updatePaymentRequest(visitId, status) {
  try {
    console.log("GET Payment Requests Start: visitId: ", visitId, status);
    const resp = await erpServices.updatePaymentRequest(visitId, status);
    console.log("Res", resp);
    return resp;
  } catch (error) {
    console.error("Error while Settling the uncleared :", error);
    throw error;
  }
}

export async function deletePaymentRequest(paymentReqId, visitId) {
  try {
    console.log("GET Payment Requests Start: visitId: ", paymentReqId, visitId);
    const resp = await erpServices.deletePaymentRequest(paymentReqId, visitId);
    console.log("Res", resp);
    return resp;
  } catch (error) {
    console.error("Error while Settling the uncleared :", error);
    throw error;
  }
}

export async function getActiveVisitLists(data) {
  try {
    console.log("GET Active visit List by : visitId: ", data);
    const resp = await patientServices.ListVisits(data);
    console.log("Res", resp);
    return resp;
  } catch (error) {
    console.error("Error while Settling the uncleared :", error);
    throw error;
  }
}

export async function getInvPDFObject(
  ticketId,
  visitId,
  customerId,
  reportType,
  locationIds
) {
  try {
    console.log("Fetch INV PDF Ticket : ", ticketId);
    const invPdfResp = await erpServices.getInvoicePDFObject(
      ticketId,
      visitId,
      customerId,
      reportType,
      locationIds
    );

    const data = await invPdfResp;
    console.log("Fetch INV PDF Resp:", data);
    return data;
  } catch (error) {
    console.error("Error while Fetching INV PDF Object:", error);
    throw error;
  }
}

export async function getReceiptPDFObject(
  receiptId,
  visitId,
  patientId,
  paymentInfo
) {
  try {
    console.log(
      "Fetch RECEIPT PDF OBJECT I/p : ",
      receiptId,
      visitId,
      patientId,
      paymentInfo
    );
    const receiptPdfObjResp = await erpServices.getReceiptPDFObject(
      receiptId,
      visitId,
      patientId,
      paymentInfo
    );

    const data = await receiptPdfObjResp;
    console.log("Fetch RECEIPT PDF Obj Resp:", data);

    return data.hmsReceiptReportDTO;
  } catch (error) {
    console.error("Error while Fetching RECEIPT PDF Object:", error);
    throw error;
  }
}

export async function getFinalBillObject(request) {
  try {
    console.log(
      "Fetch RECEIPT PDF OBJECT I/p : ",request);
    const finalBillResp = await erpServices.getFinalBill(request);

    const data = await finalBillResp;
    console.log("Fetch RECEIPT PDF Obj Resp:", data);

    return data.hmsInvReportDTOList;
  } catch (error) {
    console.error("Error while Fetching RECEIPT PDF Object:", error);
    throw error;
  }
}

export async function updateConvertKpCashKPCreditInvoice(ticketId, isKpCash) {
  try {
    console.log("Update INVOICE KPCASH_KPCREDIT CONVERSION I/p : ",ticketId, isKpCash);
    const apiUpdateResp = await erpServices.updateKpCashKPCreditInvoiceConvertion(ticketId, isKpCash);

    const data = await apiUpdateResp;
    console.log("Update INVOICE KPCASH_KPCREDIT CONVERSION Resp:", data);

    return data;
  } catch (error) {
    console.error("Error while Converting INVOICE KPCASH_KPCREDIT : ", error);
    throw error;
  }
}

export async function savePatientInvoiceQuotation(
  locationId,
  invoiceDeatils,
  erpCustId
) {
  // try {
  console.log("Save Patient Invoice Quotation Details start");
  const invoiceResponse = await erpServices.generatePatientInvoiceQuotation(
    locationId,
    invoiceDeatils,
    erpCustId
  );
  console.log("Save Patient Invoice Quotation Details response:", invoiceResponse);
  var invResp = {};
  if (invoiceResponse && invoiceResponse.erpResp) {
    invResp = invoiceResponse.erpResp;
  } else if (invoiceResponse && invoiceResponse.messageStrip) {
    // invResp['error'] = invoiceResponse.errorMessages;
    invResp["error"] = invoiceResponse.messageStrip;
  }

  return invResp;
  // } catch (error) {
  //   console.error("Error while Saving Patient Invoice Details:", error);
  //   throw error;
  // }
}

export async function searchQuotation(quotationInvDetails) {
  // try {
  console.log("Search Patient Invoice Quotation Details start");
  const invoiceResponse = await erpServices.searchInvoiceQuotation(quotationInvDetails);
  console.log("Search Patient Invoice Quotation Details response:", invoiceResponse);
  var invResp = {};
  if (invoiceResponse && invoiceResponse.erpResp) {
    invResp = invoiceResponse.erpResp;
  } else if (invoiceResponse && invoiceResponse.messageStrip) {
    // invResp['error'] = invoiceResponse.errorMessages;
    invResp["error"] = invoiceResponse.messageStrip;
  }

  return invResp;
  // } catch (error) {
  //   console.error("Error while Saving Patient Invoice Details:", error);
  //   throw error;
  // }
}

export async function fetchQuotationById(quoteId) {
  try {
    const numericQuoteId = parseInt(quoteId, 10);
    const quotePayload = {
      quoteIdList: isNaN(numericQuoteId) ? [] : [numericQuoteId],
    };
    const response = await searchQuotation(quotePayload);
    const list = response?.quotationInfoList || [];
    return (
      list.find(
        (q) =>
          q.quoteId === numericQuoteId ||
          String(q.quoteId) === String(quoteId)
      ) || list[0] || null
    );
  } catch (error) {
    console.error("fetchQuotationById error:", error);
    return null;
  }
}

export async function getQuotationPDFObject(quoteId) {
  const response = await erpServices.getQuotationPDFObject(quoteId);
  return response?.hmsInvReportDTOList || [];
}

export function successDispatch(type, data) {
  return { type: type, payload: data };
}

export function errorDispatch(type, value) {
  return { type: type, payload: value };
}

const erpActions = {
  getAllSalesOrder,
  getPatientDetails,
  getPatientAdvPayments,
  getPatientInvoices,
  getProductsList,
  deleteErpService,
  UpdateserviceListRow,
  validatePatientStatus,
  getPaymentRequests,
  updatePaymentRequest,
  deletePaymentRequest,
  getAllMasterLocationDetails,
  getInvPDFObject,
  getReceiptPDFObject,
  updateConvertKpCashKPCreditInvoice,
  removeInvoice,
  savePaymentRequests,
};

export default erpActions;
